import React, { useEffect, useState } from "react";
import { Button, Skeleton, DatePicker, Typography, message } from "antd";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, Space } from 'antd'
import { useStoreUpdaterWithAPI } from "../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../Common/APIConstants";
import ChartContainer from "../../Elements/TreeChart/ChartContainer/ChartContainer";
import { MyNode } from "../../Elements/TreeChart/CustomTemplate/Custom-Template";
import DisplayDate from "../../Elements/DisplayDate";
import { useSelector } from "react-redux";






const WaterTreeChart = () => {
    const { loading, makeRequest } = useStoreUpdaterWithAPI();
    const [nodeData, setNodeData] = useState({});
    const [meterData, setMeterData] = useState([]);
    const [skip, setSkip] = useState(true);
    const [treeChartInput, setTreeChartInput] = useState("");
    const [isTreeLoading, setIsTreeLoading] = useState(false);
    const [refetch, setRefetch] = useState(() => {});
    const [data, setData] = useState(null);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
  
  
    const mode = useSelector((state) => state.darkMode);

    const { isdarkMode } = mode;
    
  // const api = `${APIConstants.TREE_CHART_DATA_QUERY}?FromDate=${treeChartInput.FromDate}&ToDate=${treeChartInput.ToDate}`
  // console.log(api)
  
   
      const fetchData =  () => {
      
        
       
         makeRequest({
            type: APIConstants.GET,
            url: `${APIConstants.TREE_CHART_DATA_QUERY}?FromDate=${treeChartInput.FromDate}&ToDate=${treeChartInput.ToDate}`,
          }).then((res)=> {
            console.log(res)
            setData(res);
            setIsLoading(false);
            setIsError(false);
          });
          
         
      
      };
      
    //  console.log(treeChartInput)
     //to fetch initial data   data taken from settreechartinputstring
  
      useEffect(() => {
        if (treeChartInput) {
          fetchData();
        }
      }, [treeChartInput]);
      
      
    
  
     
  
  
  
    
    // TVSTreeDashBoardData?FromDate=5-7-2024&ToDate=7-6-2024
  
    // `${APIConstants.TREE_CHART_DATA_QUERY}?FromDate=5-7-2024&ToDate=7-6-2024`,
  
  
  const resetCalculation = ()=> {
    makeRequest({
      type: APIConstants.DELETE,
      url: `${APIConstants.RESET_CALCULATIONS_MUTATION}?FromDate=${treeChartInput.FromDate}&ToDate=${treeChartInput.ToDate}`,
    }).then((res)=> {
      // console.log(res)
      setData(res);
      setIsLoading(false);
      setIsError(false);
    });
  
  }
   
  
  const handleResetCalculations =  () => {
    const res1 =  resetCalculation(treeChartInput);
    info()
  
  };
    const [fromDateObj, setFromDateObj] = useState(null);// used to set default date by using handleDefautlt)it is in obj format)
    const [fromDateString, setFromDateString] = useState(null);// for api date should be string
    const [toDateObj, setToDateObj] = useState(null);
    const [toDateString, setToDateString] = useState(null);
    const [rerenderFlag, setRerenderFlag] = useState(false);
    const [timeError, setTimeError] = useState(false);
  
    const handleReset = () => {
      setRerenderFlag((prevFlag) => !prevFlag);
    };
  
  
    //to fetch date for deault 
    const setTreeChartInputString = async () => {
      try {
        const currentDate = new Date();
        const fromDate = new Date(currentDate);
        const toDate = new Date(currentDate);
        // console.log(currentDate, fromDate, toDate)
  
        fromDate.setDate(fromDate.getDate() - 1);
        fromDate.setUTCHours(7, 15, 0, 0);
        toDate.setUTCHours(7, 15, 0, 0);
        // console.log(fromDate, toDate)
  
        const defaultFormattedFromDate = fromDate.toISOString();
        const defaultFormattedToDate = toDate.toISOString();
  
        const inputFromDate = defaultFormattedFromDate;
        const inputToDate = defaultFormattedToDate;
  
        const treeChartInputData = {
          FromDate: inputFromDate,
          ToDate: inputToDate,
        };
  
        const finalInput = objectToQueryString(treeChartInputData);
        // console.log(finalInput, treeChartInput)
        setTreeChartInput(finalInput);
      } catch (error) {
        console.log(error);
      }
    };
  
    const is24HoursDifference = (fromDateTimeString, toDateTimeString) => {
      // Calculate the time difference in hours
  
      const fromDate = new Date(fromDateTimeString);
      const toDate = new Date(toDateTimeString);
  
      // Calculate the time difference in milliseconds
      const timeDifferenceInMilliseconds = toDate.getTime() - fromDate.getTime();
  
      // console.log(toDate, fromDate);
      // console.log(timeDifferenceInMilliseconds)
      const timeDifferenceInHours = (toDate - fromDate) / (1000 * 60 * 60);
      console.log(timeDifferenceInHours);
  
      // Check if the time difference is exactly 24 hours
      return timeDifferenceInHours === 24;
    };
  
  
    const fetchChartByInput = () => {
      const currentDate = new Date();
      const fromDate = new Date(currentDate);
      const toDate = new Date(currentDate);
  
      fromDate.setDate(currentDate.getDate() - 1);
      fromDate.setUTCHours(7, 15, 0, 0);
      toDate.setUTCHours(7, 15, 0, 0);
      // console.log("toDate");
      // console.log(toDate.toISOString());
      // console.log("fromDate");
      // console.log(fromDate.toISOString());
  
      const formattedFromDate = fromDate.toISOString();
      const formattedToDate = toDate.toISOString();
      // console.log("toDate")
      // console.log(formattedToDate)
      // console.log("fromDate")
      // console.log(formattedFromDate)
  
      let inputFromDate;
      let inputToDate;
  
  
  
      if (fromDateString === null && toDateString !== null) {
        inputFromDate = formattedFromDate;
        const selectedToDate = new Date(toDateString);
        selectedToDate.setUTCHours(7, 15, 0, 0);
        // console.log(is24HoursDifference(selectedFromDate,selectedToDate ))
  
        inputToDate = selectedToDate.toISOString();
      }
      if (toDateString === null && fromDateString !== null) {
        inputToDate = formattedToDate;
        const selectedFromDate = new Date(fromDateString);
  
        selectedFromDate.setUTCHours(7, 15, 0, 0);
        // console.log(is24HoursDifference(selectedFromDate,selectedToDate ))
  
        inputFromDate = selectedFromDate.toISOString();
      }
      if (toDateString !== null && fromDateString !== null) {
        const selectedFromDate = new Date(fromDateString);
        const selectedToDate = new Date(toDateString);
  
        selectedFromDate.setUTCHours(7, 15, 0, 0);
        selectedToDate.setUTCHours(7, 15, 0, 0);
        // console.log(is24HoursDifference(selectedFromDate,selectedToDate ))
  
        inputFromDate = selectedFromDate.toISOString();
        inputToDate = selectedToDate.toISOString();
      }
      if (toDateString === null && fromDateString === null) {
        inputFromDate = formattedFromDate;
        inputToDate = formattedToDate;
      }
  
      if (!is24HoursDifference(inputFromDate, inputToDate)) {
        console.log("HEllo ");
        // console.log(isLoading,isTreeLoading)
        // if (!isLoading ) {
        //   // console.log(isLoading,isTreeLoading)
        //   setTimeError(false)
        // }
        setTimeError(true);
      }
  
      // console.log(toDate.toISOString())
      // console.log(inputToDate)
      if (inputToDate === toDate.toISOString()) {
        console.log('today')
        
      const currentTime = new Date();
      const hours = currentTime.getHours();
      const minutes = currentTime.getMinutes();
      const seconds = currentTime.getSeconds();
      
      console.log(`Current time: ${hours}:${minutes}:${seconds}`);
      
      // const currentTime = new Date();
      const currentHour = currentTime.getHours();
      const currentMinute = currentTime.getMinutes();
      
      if (currentHour < 7 || (currentHour === 7 && currentMinute < 15)) {
          console.log("Current time is before 7:15 AM.");
          setTimeError(true)
      } else {
          console.log("Current time is 7:15 AM or later.");
      }
      }
  
      const treeChartInputData = {
        FromDate: inputFromDate,
        ToDate: inputToDate,
      };
  
    
      
      // console.log(inputFromDate, inputToDate)
  
      const finalInput = (treeChartInputData);
      setTreeChartInput(finalInput);
    };
  
  
  
    const [messageApi, contextHolderMessage] = message.useMessage();
    const info = () => {
      messageApi.info('Calculations reset successfully');
    };
  
  
  
  
    
  
    useEffect(() => {
      setTreeChartInputString();
    }, []);
  
    useEffect(() => {
      if (treeChartInput) {
        setSkip(false);
      }
    }, [treeChartInput]);
  
    useEffect(() => {
      setTreeData();
    }, [data]);
  
    const onSubmit = () => {
      setTimeError(false);
      setIsTreeLoading(true);
      fetchChartByInput();
    };
  
    useEffect(() => {
      fetchChartByInput();
      // setTimeError(false);
    }, []);
  
  
    useEffect(() => {
      if (isLoading) {
        setTimeError(false);
      }
    }, [isLoading]);
  
    useEffect(() => {
      if (isTreeLoading) {
        // refetch().then(() => {
          setIsTreeLoading(false);
        // });
      }
    }, [isTreeLoading]);
  
    function formatDateTimeTogether(isoTimestamp) {
      const date = new Date(isoTimestamp);
  
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2); // Months are zero-based
      const day = ("0" + date.getDate()).slice(-2);
  
      const hours = ("0" + date.getHours()).slice(-2);
      const minutes = ("0" + date.getMinutes()).slice(-2);
      const seconds = ("0" + date.getSeconds()).slice(-2);
  
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      // return `${year}-${month}-${day}`;
    }
  
    // // const isoTimestamp = '2024-02-20T07:15:00.000Z';
    // const formattedDateTime = formatDateTimeTogether(formattedFromDate);
    // console.log(formattedDateTime); // Output: 2024-02-20 07:15:00
  
    
  
    const setTreeData = () => {
      function capitalizeFirstLetter(obj) {
        const newObj = {};
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
            newObj[capitalizedKey] = obj[key];
          }
        }
        return newObj;
      }
  
      const masterArray = data?.tvsTreeDashboardMasterDetails?.map((obj) =>
        capitalizeFirstLetter(obj)
      );
  // console.log(masterArray)
      const childArray = data?.tvsTreeDashboardChildDetails?.map((obj) =>
        capitalizeFirstLetter(obj)
      );
  
      // console.log(childArray)
  
      const treeChart = (orgChartResData) => {
        const idToObjNodeMap = {};
        let root;
  
        orgChartResData?.forEach((obj) => {
          // idToObjNodeMap[obj.EntityId]=> to use EntityId as the key pass obj EntityId as key inside bracket notation
          idToObjNodeMap[obj?.EntityId] = { ...obj, children: [] }; // add new property to idToObjNodeMap object with key as EntityId and value as { ...obj, children: [] } for all items in the orgChartResData like this {1:{id:1,children:[]}} ,2:{id:2, children:[]}}
        });
  
        orgChartResData?.forEach((obj) => {
          const node = idToObjNodeMap[obj?.EntityId]; // access idToObjNodeMap items individually
          if (obj?.ParentEntityId === 0 || obj.ParentEntityId === null) {
            // if ParentEntityId is null that is root node
            root = node;
          } else if (idToObjNodeMap[obj?.ParentEntityId]) {
            // if other than root node has ParentEntityId push that node to corresponding parent's children array.
            idToObjNodeMap[obj?.ParentEntityId]?.children.push(node);
          }
        });
  
        return root;
      };
  
      const treeData = treeChart(masterArray);
      // console.log(treeData)
  
      setNodeData(treeData);
      setMeterData(childArray);
    };
  
    const onChangeFromDate = (date, dateString) => {
      setFromDateString(dateString);
      setFromDateObj(date);
    };
  
    const onChangeToDate = (date, dateString) => {
      setToDateString(dateString);
      setToDateObj(date);
    };
  
  
    //to display date 
    const handleDefaultDate = () => {
      const currentDate = new Date(); // create new data obj
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth(); // Get current month (0-indexed 0-jan)
      const fromTime = 7; // 7:00 AM
      const toTime = 7; // 7:00 AM
  
      //from date
      const fromDate = new Date(
        currentYear,
        currentMonth,
        currentDate.getDate() - 1,
        fromTime,
        15,
        0,
        0
      );
  
  
      //to date
      const toDate = new Date(
        currentYear,
        currentMonth,
        currentDate.getDate(),
        toTime,
        15,
        0,
        0
      );
  
      const formatDate = (date) => {
        return date.toDateString() + " " + date.toLocaleTimeString();
      };
      const startDate = dayjs(formatDate(fromDate));
      const endDate = dayjs(formatDate(toDate));
  
      // console.log(startDate, endDate)
      setFromDateObj(startDate);
      setToDateObj(endDate);
    };
  
    useEffect(() => {
      handleDefaultDate();
    }, []);
  
  
    //default date to display in date box initially
    // const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    const dateFormat = "YYYY-MM-DD";
  
    const currentDate = new Date();
    const fromDate = new Date(currentDate);
    const toDate = new Date(currentDate);
    const maxToDate= new Date(currentDate);
  
    fromDate.setDate(currentDate.getDate() - 1);
    fromDate.setUTCHours(7, 15, 0, 0);
    toDate.setUTCHours(7, 15, 0, 0);
  
    maxToDate.setDate(currentDate.getDate()+1)
  
    // const formattedFromDate = formatDateTimeTogether(fromDate);
    const formattedToDate = formatDateTimeTogether(toDate);
    const formattedMaxToDate = formatDateTimeTogether(maxToDate);
  
    // console.log(formattedToDate);
    // console.log(formattedMaxToDate);
    const maximumToDate = dayjs(formattedMaxToDate, dateFormat);
    const maxDate = dayjs(formattedToDate, dateFormat);
  
    const [modal, contextHolder] = Modal.useModal();
    const confirm = () => {
      modal.confirm({
        title: 'Confirm',
        icon: <ExclamationCircleOutlined />,
        content: <>
        <p>Selected respective dates data will be  deleted.</p>
        </>,
        okText: 'Confirm',
        cancelText: 'Cancel',
        okButtonProps: {
          type: 'secondary', 
          style: { background: 'green',color:'white', borderColor: 'green' }
        },
        cancelButtonProps: {
          type: 'secondary', 
          style: { color:'red', borderColor: 'red' }
        },
        onOk() {
          handleResetCalculations()
        },
  
      });
    };
  
    
    return (
      <>
        <div>
        <DisplayDate
            fromDateObj={fromDateObj}
            toDateObj={toDateObj}
            onChangeFromDate={onChangeFromDate}
            onChangeToDate={onChangeToDate}
            onSubmit={onSubmit}
            handleReset={handleReset}
            handleResetCalculations={handleResetCalculations}
          />
          {isLoading && !isError && (
               <div className={`m-[10px] rounded-md h-screen flex justify-center ${isdarkMode ? 'darkmode' : 'whitemode'}`}>
              <div className="w-[200px] pt-4">
                <Skeleton active />
              </div>
            </div>
          )}
          {isTreeLoading && (
            <div className="bg-white m-[10px] rounded-md h-screen flex justify-center ">
              <div className="w-[200px] pt-4">
                <Skeleton active />
              </div>
            </div>
          )}
          {timeError && !isLoading && !isTreeLoading && !isError && (
            <div className="bg-white m-[10px] rounded-md h-screen flex justify-center ">
              <div className="w-[200px] pt-4">
                <div className="flex flex-col justify-center">
                  <img className="w-[200px] h-[100px] " src={errorNew} />
                  <p className="text-sm text-red-500 text-center">
                    Incorrect Time{" "}
                  </p>
                  <p className="text-center">Please select the time currectly </p>
                </div>
              </div>
            </div>
          )}
          {!isLoading && !isTreeLoading && !isError && !timeError && (
            <ChartContainer
              rerenderFlag={rerenderFlag}
              chartClass="myChart"
              NodeTemplate={MyNode}
              datasource={nodeData}
              meterData={meterData}
            />
          )}
          {isError && (
            <div className="bg-white m-[10px] rounded-md h-screen flex justify-center ">
              <div className="w-[200px] pt-4">
                <div className="flex flex-col justify-center">
                  <img className="w-[200px] h-[100px] " src={errorNew} />
                  <p className="text-sm text-red-500 text-center">Server error</p>
                  <p className="text-center">Please reload the page</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  };
  
  export default WaterTreeChart;


const ConfirmModal = () => {
    const [open, setOpen] = useState(false);
    const showModal = () => {
      setOpen(true);
    };
    const hideModal = () => {
      setOpen(false);
    };
    return (
      <>
        <Button type="primary" onClick={showModal}>
          Modal
        </Button>
        <Modal
          title="Modal"
          open={open}
          onOk={hideModal}
          onCancel={hideModal}
          okText="OK"
          cancelText="Cancel"
        >
          <p>Hllo</p>
          <p>Bla bla ...</p>
          <p>Bla bla ...</p>
          <p>Bla bla ...</p>
        </Modal>
      </>
    );
  };